export const getMakesWithModelsOptions = ({makesWithModels = []}) =>
  makesWithModels.map(({make, models = []}) => ({
    id: make.id,
    label: make.name,
    models: models.map(({id, name}) => ({id, label: name}))
  }))

/**
 * Enriches user alerts with make and model names
 * using optimized maps for O(1) lookup performance
 */
export const enrichUserAlertsWithVehicleNames = (userAlerts, makesWithModels) => {
  if (!makesWithModels?.length || !userAlerts?.length) {
    return userAlerts
  }

  // Create optimized maps for O(1) lookup
  const makesMap = new Map()
  const modelsMap = new Map()

  // Single iteration to build both maps
  makesWithModels.forEach(({make, models}) => {
    if (make?.id && make?.name) {
      makesMap.set(String(make.id), make.name)

      // Create models map with composite key makeId:modelId
      models?.forEach(model => {
        if (model?.id && model?.name) {
          const key = `${make.id}:${model.id}`
          modelsMap.set(key, model.name)
        }
      })
    }
  })

  // Enrich alerts with names
  return userAlerts.map(alert => {
    if (!alert?.filters?.vehicles?.length) {
      return alert
    }

    const enrichedVehicles = alert.filters.vehicles.map(vehicle => {
      const makeId = String(vehicle.makeId)
      const modelId = String(vehicle.model?.id || vehicle.modelId)
      const modelKey = `${makeId}:${modelId}`

      return {
        ...vehicle,
        make: makesMap.get(makeId) || null,
        model: {
          ...vehicle.model,
          id: vehicle.model?.id || vehicle.modelId,
          name: modelsMap.get(modelKey) || vehicle.model?.name || null
        }
      }
    })

    return {
      ...alert,
      filters: {
        ...alert.filters,
        vehicles: enrichedVehicles
      }
    }
  })
}
